import { ShippingProviders } from '@app/shared/constants';

/**
 * Feed badge for UniUni shipment rows: PostNL-routed shipments carry a structural
 * metadata.isPostnlUniuniShipment === true indicator; anything else (absent, false, malformed,
 * non-boolean truthy values) is UniUni-direct. Non-UniUni rows get no badge.
 *
 * Extracted so /reconciliation and the Finance "not invoiced" tabs (via ShipmentsListComponent's
 * showUniuniRoutingBadge input) share one implementation of the PostNL/Direct distinction instead
 * of reimplementing the strict-boolean check per screen.
 */
export function getUniuniRoutingBadge(shipment: any): 'PostNL' | 'Direct' | null {
  if (!shipment || shipment.provider !== ShippingProviders.UNIUNI) {
    return null;
  }
  return shipment.metadata && shipment.metadata.isPostnlUniuniShipment === true ? 'PostNL' : 'Direct';
}
